import React from 'react'
import {
  Route,
  browserHistory,
} from 'react-router'

/** Route pages */

const GuestNotFound = () => {
  const Routes = () => (
    <Route
      path="*"
      component={() => (<div />)}
      onEnter={
        () => {
          browserHistory.push('/')
        }
      }
    />
  )

  return Routes()
}

export default GuestNotFound
